import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { utils as commonUtils } from '@febos-io/common';
import { utils as designUtils } from '@febos-io/design';
import { getIsFederated, removeUser } from '../../store';
import { useAuthContext } from '../../providers';
import useTranslation from '../useTranslation';

const { Auth } = commonUtils;

export function useSignOut() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { signOutRedirectPathname } = useAuthContext();
  const isFederated = useSelector(getIsFederated);
  const onSignOutClick = useCallback(async () => {
    try {
      setLoading(true);
      dispatch(removeUser());
      localStorage.removeItem('username');
      localStorage.removeItem('keyPrefix');
      setLoading(false);
      if (isFederated) {
        const exit = await Auth.signOut();
        console.log('federated', exit);
      } else {
        console.log('not federated');
        await Auth.signOut();
        if (signOutRedirectPathname) {
          navigate(signOutRedirectPathname);
        }
      }
    } catch (error) {
      setLoading(false);
      designUtils.error(t('Something went wrong'));
      commonUtils.errorHandler(error);
    }
  }, [dispatch, isFederated, navigate, signOutRedirectPathname, t]);

  return {
    loading,
    onSignOutClick
  };
}

export default useSignOut;
